var _ = require('underscore');
var TorsoFormView = require('backbone-torso/modules/FormView');
var payableBillsItemTemplate = require('./payableBillsItemTemplate.hbs');
var PaymentDetailsBillModalView = require('./PaymentDetailsBillModalView');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var billingConfigModel = require('./../financial/billingConfigModel');
var inputUtils = require('./../utils/inputUtils');

/**
 * Form view for Make Payment Payable Bills Item
 *
 * @class PayableBillsItemView
 */
module.exports = TorsoFormView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--border portal-list__item--payable-item',
  attributes: {
    'data-test-list-item': true
  },
  template: payableBillsItemTemplate,

  behaviors: {
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  prepareFields: {
    billMessage: '_billMessageModel',
    billPaymentDetail: function() {
      var identifier = this._billMessageModel.getIdentifier();
      return this.model.get('billPaymentDetails.' + identifier);
    },
    identifier: function() {
      return this._billMessageModel.getIdentifier();
    }
  },

  events: {
    'click [data-show-details-modal]': '_showEStatementModal',
    'keypress [data-payment-amount-field]': function(event) {
      inputUtils.sanitizeAmount(event);
    },
    'click [data-pay-full-btn]': '_payFull',
    'click [data-pay-none-btn]': '_payNone'
  },

  /**
   * Configures feedback bindings.
   * @property feedback {Array of When/Then Feedbacks}
   */
  feedback: [
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we format the amount to currency.
     * @property feedback[0] (Payment Amount Input Field Formatting) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['blur']
      },
      then: function(event, indexMap) {
        this.model.formatAmount(indexMap.identifier);
        var result = this.model.get('billPaymentDetails[' + indexMap.identifier + '].amount');
        return { val: result };
      },
      to: 'billPaymentDetails[identifier].amount'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is not greater than the amount due.
     * If it is, it will highlight the input field.
     * @property feedback[1] (Payment Amount Input Field Styling) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function(event, indexMap) {
        var errorMessage = this._validateInput(indexMap);
        return errorMessage.error ? { addClass: 'brec-form__input--error' } : { removeClass: 'brec-form__input--error' };
      },
      to: 'billPaymentDetails[identifier].amount'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is not greater than the amount due.
     * If it is, it will show the error container.
     * @property feedback[2] (Payment Amount Error Styling) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function(event, indexMap) {
        var errorMessage = this._validateInput(indexMap);
        if (errorMessage.error) {
          return {
            removeClass: 'brec-hidden',
            attr: ['aria-hidden', 'false']
          };
        } else {
          return {
            addClass: 'brec-hidden',
            attr: ['aria-hidden', 'true']
          };
        }
      },
      to: 'paymentAmountError[identifier]'
    },
    /**
     * When someone blurs from the partial payment amount input field,
     * Then we verify the amount entered is not greater than the amount due.
     * If it is, it will show the error message.
     * @property feedback[3] (Payment Amount Error Message) {When/Then Feedback}
     */
    {
      when: {
        '@billPaymentDetails[identifier].amount' : ['keyup', 'blur'],
        'listenTo': [
          {
            object: 'model',
            events: 'change:billPaymentDetails'
          }
        ]
      },
      then: function() {
        var errors = this.model.preValidate(['billPaymentDetails']);
        if (_.isEmpty(errors)) {
          return { text: ''};
        } else {
          return { text: this.format('payment.payableBillsItem.error.overpay') };
        }
      },
      to: 'paymentAmountErrorMsg[identifier]'
    }
  ],

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.billMessageModel {SecureMessageModel} the model containing the bill secure message for this item.
   *   @param options.context {Object} the item context from the list view parent.
   *     @param options.context.paymentDetailsFormModel {PaymentDetailsFormModel} the form model to use.
   *   @param options.billId {Number} the id for a bill item.
   * @override
   */
  initialize: function(options) {
    this._billMessageModel = options.billMessageModel;
    this.model = options.context.paymentDetailsFormModel;
    this.billId = options.billId;
    var identifier = this._billMessageModel.getIdentifier();
    this.listenTo(this.model, 'change:billPaymentDetails.' + identifier + '.paid billPaid', this.render);
    this.set('payPartial', false);
    this.listenTo(this.viewState, 'change:payPartial', this.render);
    billingConfigModel.loadOnce();
  },

  /**
   * Displays the e-statement modal.
   * @method _showEStatementModal
   * @param event {jQuery.Event} the event that triggered this function call.
   * @private
   */
  _showEStatementModal: function(event) {
    if (event) {
      event.preventDefault();
      var billIdString = $(event.target).attr('data-bill-id');
      var billId = Number(billIdString);
      if (billId) {
        this._eStatementModalView = new PaymentDetailsBillModalView({
          billId: billId
        });
        this.showModal(this._eStatementModalView);
      }
    }
  },

  /**
   * Validate the amount input field and return the error associated with the input field.
   * @param indexMap {Object} the indexMap of the input field
   * @method _validateInput
   * @private
   */
  _validateInput: function(indexMap) {
    var errors = this.model.preValidate(['billPaymentDetails']) || {};
    var errorMessages = errors.billPaymentDetails;
    return _.findWhere(errorMessages, {paymentIdentifier: indexMap.identifier}) || {};
  },

  /**
   * Set payment amount to amount due.
   * @method _payFull
   * @private
   */
  _payFull: function() {
    this.model.payFull(this._billMessageModel);
  },

  /**
   * Set payment amount to 0.
   * @method _payNone
   * @private
   */
  _payNone: function() {
    this.model.payNone(this._billMessageModel);
  }
});
